import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2ed39fb5")

_pushScopeId("data-v-2ed39fb5")
const _hoisted_1 = { class: "input__datetime__date" }
const _hoisted_2 = { class: "label-wrapped" }
const _hoisted_3 = { for: "purpose-date -bold" }
const _hoisted_4 = {
  key: 0,
  class: "selected-date"
}
const _hoisted_5 = { class: "input__datetime__time label-wrapped" }
const _hoisted_6 = {
  for: "purpose-time",
  class: "-bold"
}
const _hoisted_7 = { class: "input__datetime--desc" }
const _hoisted_8 = {
  key: 1,
  class: "input__datetime--scheduled-datetime -readonly"
}
const _hoisted_9 = { style: {"min-width":"80px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")

  return (_openBlock(), _createBlock("div", {
    class: ["input__datetime", _ctx.isLine ? 'isLine' : 'notIsLine']
  }, [
    (_ctx.state.isEditable)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("label", _hoisted_3, _toDisplayString(_ctx.t('desired date')), 1),
              (_ctx.isLine)
                ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.selectDate), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_Calendar, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.date = $event)),
              dateFormat: "yy-mm-dd",
              disabledDays: _ctx.state.disabledDays,
              disabled: _ctx.isCalendarDisabled,
              minDate: _ctx.dateLimit.minDate,
              maxDate: _ctx.dateLimit.maxDate,
              manualInput: false,
              disabledDates: _ctx.state.invalidDates,
              inline: _ctx.state.isLine,
              touchUI: !_ctx.state.isLine,
              id: "purpose-date"
            }, null, 8, ["modelValue", "disabledDays", "disabled", "minDate", "maxDate", "disabledDates", "inline", "touchUI"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("label", _hoisted_6, _toDisplayString(_ctx.t('desired time')), 1),
            (_ctx.state.isEditable)
              ? (_openBlock(), _createBlock(_component_Dropdown, {
                  key: 0,
                  modelValue: _ctx.state.purpose.time,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.purpose.time = $event)),
                  options: _ctx.state.enableTimeList,
                  disabled: !_ctx.state.purpose.date || _ctx.state.disabled,
                  id: "purpose-time"
                }, null, 8, ["modelValue", "options", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("span", _hoisted_7, [
            _createVNode("small", null, [
              _createVNode("b", null, _toDisplayString(_ctx.t('korea standard time')) + "(KST, UTC/GMT+09:00)", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.t('time standard')), 1)
            ]),
            _createVNode("small", null, _toDisplayString(_ctx.t('desired date/time can be selected after doctor selected')), 1)
          ])
        ], 64))
      : (_openBlock(), _createBlock("section", _hoisted_8, [
          _createVNode("label", null, _toDisplayString(_ctx.t('scheduled date/time')), 1),
          _createVNode("div", _hoisted_9, _toDisplayString(_ctx.state.purpose.date ?? "") + " " + _toDisplayString(_ctx.state.purpose.time ?? ""), 1)
        ]))
  ], 2))
})